<script lang="ts">
  import { assets } from '$app/paths';
  import { onMount } from 'svelte';
  import * as d3 from 'd3';

  let { members, altText } = $props();

  let membersCountByStance = [
    {
      stance: 'dove',
      count: 0,
    },
    {
      stance: 'dovish',
      count: 0,
    },
    {
      stance: 'centrist',
      count: 0,
    },
    {
      stance: 'hawkish',
      count: 0,
    },
    {
      stance: 'hawk',
      count: 0,
    },
  ];

  const width = 630;
  const height = 8;
  const marginTop = 0;
  const marginRight = 0;
  const marginBottom = 0;
  const marginLeft = 0;
  const targetLabelFontSizePx = 16;

  function capitalizeFirstLetter(val) {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
  }

  onMount(() => {
    members.forEach((member) => {
      const stance = membersCountByStance.find(
        (s) => s.stance === member.scale
      );
      if (stance) {
        stance.count++;
      }
    });

    let series = d3
      .stack()
      .keys(d3.union(membersCountByStance.map((d) => d.stance))) // distinct series keys, in input order
      .value(([, D], key) => D.get(key).count) // get value for each series key and stack
      .offset(d3.stackOffsetExpand)(
      d3.index(
        membersCountByStance,
        () => 'all',
        (d) => d.stance
      )
    ); // group by stack then series key

    let x = d3
      .scaleLinear()
      .domain([0, d3.max(series, (d) => d3.max(d, (d) => d[1]))])
      .rangeRound([marginLeft, width - marginRight]);

    let color = d3
      .scaleOrdinal()
      .domain(series.map((d) => d.key))
      .range(['#54278f', '#9582c1', '#595959', '#74c476', '#006d2c'])
      .unknown('#ccc');

    // console.log('Number of members in each stance:', membersCountByStance);
    // console.log('Stacked data for the chart:', series[0]);

    // A function to format the value in the tooltip.
    const formatValue = (x) => (isNaN(x) ? 'N/A' : x.toLocaleString('en'));

    // Create the SVG container.
    const svg = d3
      .select('.stance-bar')
      .append('svg')
      .attr('width', width)
      .attr('height', height + marginTop + marginBottom)
      .attr('viewBox', [0, 0, width, height + marginTop + marginBottom])
      .attr('style', 'max-width: 100%;');

    const resizeStanceBar = () => {
      svg.selectAll('rect').each(function (d) {
        const rectData = d as [number, number] & { key: string; data: any };

        var fullLabelContainerWidth = document
          .querySelector('.stance-bar-label-container')
          .getBoundingClientRect().width;

        // Only add labels for segments that are wide enough
        if (x(rectData[1]) - x(rectData[0]) > 50) {
          document
            .querySelector(`.stance-bar-label.${rectData.key}`)
            .setAttribute(
              'style',
              `width: ${(fullLabelContainerWidth / width) * (x(rectData[1]) - x(rectData[0]))}px; color: ${color(rectData.key)}; opacity: 1; transition: opacity 1s;`
            );
        } else {
          document
            .querySelector(`.stance-bar-label.${rectData.key}`)
            .setAttribute(
              'style',
              `width: ${(fullLabelContainerWidth / width) * (x(rectData[1]) - x(rectData[0]))}px; color: ${color(rectData.key)}; opacity: 0; transition: opacity 1s;`
            );
        }
      });
    };

    // console.log('Stacked data for the chart:', series);

    svg
      .append('g')
      .selectAll()
      .data(series)
      .join('g')
      .attr('fill', (d) => color(d.key))
      .attr('class', 'rect-stance')
      .selectAll('rect')
      .data((D) => D.map((d) => ((d.key = D.key), d)))
      .join('rect')
      .attr('x', (d) => x(d[0]))
      .attr('y', marginTop)
      .attr('height', height)
      .transition()
      .duration(1000)
      .attr('width', (d) => x(d[1]) - x(d[0]));

    resizeStanceBar();

    window.addEventListener('resize', resizeStanceBar);

    return () => {
      window.removeEventListener('resize', resizeStanceBar);
    };
  });
</script>

<div
  class="article-block fmx-auto normal stance-bar-wrapper"
  aria-label={altText}
>
  <div class="stance-bar-title">Overall breakdown of current Fed members</div>
  <div class="stance-bar"></div>
  <div class="stance-bar-label-container">
    <div class="stance-bar-label dove" style="opacity:0">Dove</div>
    <div class="stance-bar-label dovish" style="opacity:0">Dovish</div>
    <div class="stance-bar-label centrist" style="opacity:0">Centrist</div>
    <div class="stance-bar-label hawkish" style="opacity:0">Hawkish</div>
    <div class="stance-bar-label hawk" style="opacity:0">Hawk</div>
  </div>
</div>
